import { createAtom, useAtom } from "../structures/jazzi/atom";

export type Route = "login" | "home" | "tab" 

export const RouteAtom = createAtom<Route>("login", (a,b) => a === b);

export const useRoute = () => useAtom(RouteAtom)